import { Component, Input, OnInit } from '@angular/core';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { CompetenciaLocalService } from '../../competencia-local/competencia-local.service';
import { OrgaoJulgadorColegiadoLocalService } from '../../orgao-julgador-colegiado-local/orgao-julgador-colegiado-local.service';
import { OrgaoJulgadorLocalService } from '../../orgao-julgador-local/orgao-julgador-local.service';
import { OrgaoJusticaService } from '../../orgao-justica/orgao-justica.service';
import { TipoParteLocalService } from '../../tipo-parte-local/tipo-parte-local.service';
import { TipoProcessoDocumentoLocalService } from '../../tipo-processo-documento-local/tipo-proc-doc-loc.service';
import { FonteDados } from '../fonte-dados.model';
import { FonteDadosMensagemErroService } from '../fonte-dados-mensagem-erro.service';
import { JurisdicaoLocalService } from '../../jurisdicao-local/jurisdicao-local.service';

export class TipoEntidadeProcessamento {
  situacao = TipoEntidadeProcessamentoSituacao.INICIAL;
  constructor(public tipo: TipoEntidade, public nome: string) {}
}

export enum TipoEntidade {
  COMPETENCIA = 'COMPETENCIA',
  TIPO_PARTE = 'TIPO_PARTE',
  TIPO_PROCESSO_DOCUMENTO = 'TIPO_PROCESSO_DOCUMENTO',
  ORGAO_JULGADOR = 'ORGAO_JULGADOR',
  ORGAO_JULGADOR_COLEGIADO = 'ORGAO_JULGADOR_COLEGIADO',
  JURISDICAO_LOCAL = ' JURISDICAO_LOCAL',
}

export enum TipoEntidadeProcessamentoSituacao {
  INICIAL = 'INICIAL',
  SINCRONIZANDO = 'SINCRONIZANDO',
  SINCRONIZADO = 'SINCRONIZADO',
  FALHA_SINCRONIZACAO = 'FALHA_SINCRONIZACAO',
}

@Component({
  selector: 'app-fonte-dados-visualizador-de-para',
  templateUrl: './fonte-dados-visualizador-de-para.component.html',
  styleUrls: ['./fonte-dados-visualizador-de-para.component.css'],
})
export class FonteDadosVisualizadorDeParaComponent implements OnInit {
  public tipos: TipoEntidadeProcessamento[];

  @Input()
  public fonteDados: FonteDados;

  constructor(
    public orgaoJusticaService: OrgaoJusticaService,
    public orgaoJulgadorLocalService: OrgaoJulgadorLocalService,
    public competenciaLocalService: CompetenciaLocalService,
    public tipoProcessoDocumentoLocalService: TipoProcessoDocumentoLocalService,
    public tipoParteLocalService: TipoParteLocalService,
    public orgaoJulgadorColegiadoLocalService: OrgaoJulgadorColegiadoLocalService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private fonteDadosMensagemErroService: FonteDadosMensagemErroService,
    private jurisdicaoLocalService: JurisdicaoLocalService
  ) {}

  ngOnInit(): void {
    if (this.fonteDados !== undefined) {
      this.progressoService.modal();

      this.tipos = [
        new TipoEntidadeProcessamento(TipoEntidade.COMPETENCIA, 'Competência'),
        new TipoEntidadeProcessamento(TipoEntidade.TIPO_PARTE, 'Tipo Parte'),
        new TipoEntidadeProcessamento(TipoEntidade.TIPO_PROCESSO_DOCUMENTO, 'Tipo Processo Documento'),
        new TipoEntidadeProcessamento(TipoEntidade.ORGAO_JULGADOR, 'Orgão Julgador'),
        new TipoEntidadeProcessamento(TipoEntidade.ORGAO_JULGADOR_COLEGIADO, 'Orgão Julgador Colegiado'),
        new TipoEntidadeProcessamento(TipoEntidade.JURISDICAO_LOCAL, 'Jurisdição Local'),
      ];
    }
  }

  public sincronizarTudo() {
    this.tipos.forEach((tipo) => {
      this.sincronizarTipo(tipo);
    });
  }

  public sincronizarTipo(tipo: TipoEntidadeProcessamento) {
    this.progressoService.modal();

    tipo.situacao = TipoEntidadeProcessamentoSituacao.SINCRONIZANDO;

    switch (tipo.tipo) {
      case TipoEntidade.COMPETENCIA:
        this.competenciaLocalService
          .sincronizar(this.fonteDados)
          .then((_) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.SINCRONIZADO;
            this.progressoService.fechar();
          })
          .catch((response) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.FALHA_SINCRONIZACAO;
            this.fonteDadosMensagemErroService.apresentarErro(
              'Erro ao sincronizar as competências da fonte de dados',
              'Sincronizar competências',
              response
            );
            this.progressoService.fechar();
          });
        break;
      case TipoEntidade.ORGAO_JULGADOR:
        this.orgaoJulgadorLocalService
          .sincronizar(this.fonteDados)
          .then((_) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.SINCRONIZADO;
            this.progressoService.fechar();
          })
          .catch((response) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.FALHA_SINCRONIZACAO;
            this.fonteDadosMensagemErroService.apresentarErro(
              'Erro ao sincronizar os órgãos julgadores da fonte de dados',
              'Sincronizar órgãos julgadores',
              response
            );
            this.progressoService.fechar();
          });
        break;
      case TipoEntidade.ORGAO_JULGADOR_COLEGIADO:
        this.orgaoJulgadorLocalService
          .sincronizar(this.fonteDados)
          .then((_) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.SINCRONIZADO;
            this.progressoService.fechar();
          })
          .catch((response) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.FALHA_SINCRONIZACAO;
            this.fonteDadosMensagemErroService.apresentarErro(
              'Erro ao sincronizar os órgãos julgadores colegiados da fonte de dados',
              'Sincronizar órgãos julgadores colegiados',
              response
            );
            this.progressoService.fechar();
          });
        break;
      case TipoEntidade.TIPO_PARTE:
        this.tipoParteLocalService
          .sincronizar(this.fonteDados)
          .then((_) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.SINCRONIZADO;
            this.progressoService.fechar();
          })
          .catch((response) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.FALHA_SINCRONIZACAO;
            this.fonteDadosMensagemErroService.apresentarErro(
              'Erro ao sincronizar os tipos de partes da fonte de dados',
              'Sincronizar tipos de partes',
              response
            );
            this.progressoService.fechar();
          });
        break;
      case TipoEntidade.TIPO_PROCESSO_DOCUMENTO:
        this.tipoProcessoDocumentoLocalService
          .sincronizar(this.fonteDados)
          .then((_) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.SINCRONIZADO;
            this.progressoService.fechar();
          })
          .catch((response) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.FALHA_SINCRONIZACAO;
            this.fonteDadosMensagemErroService.apresentarErro(
              'Erro ao sincronizar os tipos de documentos da fonte de dados',
              'Sincronizar tipos de documentos',
              response
            );
            this.progressoService.fechar();
          });
        break;
      case TipoEntidade.JURISDICAO_LOCAL:
        this.jurisdicaoLocalService
          .sincronizar(this.fonteDados)
          .then((_) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.SINCRONIZADO;
            this.progressoService.fechar();
          })
          .catch((response) => {
            tipo.situacao = TipoEntidadeProcessamentoSituacao.FALHA_SINCRONIZACAO;
            this.fonteDadosMensagemErroService.apresentarErro(
              'Erro ao sincronizar os órgãos julgadores locais da fonte de dados',
              'Sincronizar órgãos julgadores locais',
              response
            );
            this.progressoService.fechar();
          });
        break;
    }
  }
}
